<template>
    <v-dialog
        v-model="dialog"
        width="600"
        persistent
    >
        <v-btn
        slot="activator"
        flat
        icon
        color="green" >
            <v-icon>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title class="headline grey lighten-4" primary-title>
                {{ editing ? '更改貨品資料' : '新增貨品' }}
            </v-card-title>
            <v-card-text>
                <v-form ref="form" lazy-validation>
                    <template v-if="selected === 0">
                        <div style="display: flex;flex-flow: column;height: 250px;">
                            <div style="flex: 1;display: flex;align-items: center;justify-content: center;">
                                <v-btn color="primary" @click="detail={'product': {}}" depressed large>選擇現成貨品</v-btn>
                            </div>
                            <div style="flex: 1;display: flex;align-items: center;justify-content: center;">
                                <v-btn color="primary" @click="detail={}" depressed large>輸入自訂貨品</v-btn>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="selected === 1">
                        <product-select v-model="detail['product']" />
                        <v-layout wrap pa-3>
                            <v-flex xs12>
                                <v-textarea
                                v-model="detail['side_note']"
                                :row="5"
                                :rules="[v => (typeof(v) !== 'string' || v.length <= 200) || '字數不能大於200']"
                                name="input-7-1"
                                :label="`貨品備註 ${detail['side_note'] ? detail['side_note'].length : 0}/200`"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs5 md3 offset-md2 >
                                <v-text-field
                                :rules="[v => typeof(v) === 'number' || '必填項目', v => v <= 0 ? '必須大於0' : true]"
                                v-model.number="detail['quantity']"
                                label="*貨品數量"
                                required
                                type="number"
                                prefix="x"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 offset-xs1>
                                <v-text-field
                                :rules="[v => typeof(v) === 'number' || '必填項目']"
                                v-model.number="detail['price']"
                                label="*貨品價錢"
                                required
                                type="number"
                                prefix="$"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </template>
                    <template v-else-if="selected === 2">
                        <v-layout wrap pa-3>
                            <v-flex xs6>
                                <supplier-select v-model="detail['supplier']" />
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field :rules="[v => !!v || '必填項目']" v-model="detail['name']" label="*貨品名/編號" required></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                v-model="detail['side_note']"
                                :row="5"
                                :rules="[v => (typeof(v) !== 'string' || v.length <= 200) || '字數不能大於200']"
                                name="input-7-1"
                                :label="`貨品備註 ${detail['side_note'] ? detail['side_note'].length : 0}/200`"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs5 md3 offset-md2 >
                                <v-text-field
                                :rules="[v => typeof(v) === 'number' || '必填項目', v => v <= 0 ? '必須大於0' : true]"
                                v-model.number="detail['quantity']"
                                label="*貨品數量"
                                required
                                type="number"
                                prefix="x"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 offset-xs1>
                                <v-text-field
                                :rules="[v => typeof(v) === 'number' || '必填項目']"
                                v-model.number="detail['price']"
                                label="*貨品價錢"
                                required
                                type="number"
                                prefix="$"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <small>*為必填項目</small>
                    </template>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="backButtonPressed">{{ selected ? '返回' : '關閉' }}</v-btn>
                <v-btn v-if="selected > 0" color="primary" flat @click.native="confirm">{{ editing ? '更改' : '新增' }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
        
</template>

<script>
import _ from 'lodash'

import ProductSelect from './ProductSelect'
import SupplierSelect from './SupplierSelect'

export default {
    props: {
        value: {
            type: Object,
            default: () => null
        }
    }, 
    data() {
        return {
            dialog: false,
            detail: null,
            editing: false
        }
    },
    computed: {
        selected() {
            return this.detail === null ? 0 : this.detail.product ? 1 : 2
        }
    },
    watch: {
        dialog(x) {
            if (x) this.editing = this.detail ? true : false
        }
    },
    methods: {
        open() {
            this.$nextTick(() => {
                this.detail = _.cloneDeep(this.value)
            })
            this.dialog = true
        },
        backButtonPressed() {
            if (this.selected > 0) this.detail = null
            else {
                this.dialog = false
                this.detail = null
            }
        },
        confirm() {
            if (this.$refs.form.validate()) {
                if (this.editing) this.$emit('edit', this.detail)
                else this.$emit('new', this.detail)

                this.dialog = false
            }
        }
    },
    components: { ProductSelect, SupplierSelect }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ProductInput.vue